import { getConfig } from './utils/config';

export const BASE_URL = getConfig('base_url');

export const API_URL = getConfig(
  'api_url',
  'https://api.develop.beckhoff-web-services.com/api/v3/downloadfinder/',
);

export const RESULTS_PAGE = getConfig('resultsPage');

// download type for direct or login required link
export const DOWNLOAD_TYPE = {
  LOGIN: 'cart',
  DIRECT: 'direct',
};

export const PINNED_STORAGE_KEY = 'df-pinned';

export const TRANSLATION_SEPARATOR = '%%';

// zip limit reached at 3GB
export const MAX_ZIP_SIZE = 3221225472;

export const PER_PAGE = 12;

export const CACHE_TIME = 5 * 60000;

export const PAGE_VARIANT = {
  SEARCH: 'startpage',
  RESULT: 'resultspage',
  BOOKMARK: 'bookmarkpage',
};
